var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"gl-inline-flex gl-items-center gl-gap-2"},[_c('span',[_vm._v(_vm._s(_vm.sessionLabel))]),_vm._v(" "),_c('gl-badge',{attrs:{"variant":"neutral"}},[_vm._v(_vm._s(_vm.s__('DuoAgentPlatform|Subagent')))]),_vm._v(" "),(_vm.status)?_c('gl-badge',{attrs:{"variant":_vm.statusVariant}},[_vm._v(_vm._s(_vm.statusText))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }